import {
  APISortOption,
  APISortOrder,
} from '@aboutyou/backbone/endpoints/products/products'

import { ProductSortingIdType, SortingChannels } from 'constants/sorting'
import { SelectedLooseFilterMapType } from 'store/sidecar/FilterViewStore'

const SORTING_QUERY_KEY = 'sort'

const productSortingIds: ProductSortingIdType[] = [
  'reduction_highest',
  'new_first',
  'price_high',
  'price_low',
  'topseller',
]

type SortKey = {
  sortOption: APISortOption | null
  sortOrder: APISortOrder
}

export const extractSortIdFromQuery = (query: {
  [key: string]: string
}): ProductSortingIdType => {
  const sortIdQueryValue = query[SORTING_QUERY_KEY] as
    | ProductSortingIdType
    | undefined

  let rawSortId: ProductSortingIdType = 'topseller'

  if (!sortIdQueryValue) {
    return rawSortId
  }

  if (productSortingIds.includes(sortIdQueryValue)) {
    rawSortId = sortIdQueryValue
  }

  return rawSortId
}

export const mapSortValues = (sortingId: ProductSortingIdType): SortKey => {
  switch (sortingId) {
    case 'reduction_highest':
      return {
        sortOption: APISortOption.Reduction,
        sortOrder: APISortOrder.Descending,
      }

    case 'new_first':
      return {
        sortOption: APISortOption.DateAdded,
        sortOrder: APISortOrder.Descending,
      }

    case 'price_high':
      return {
        sortOption: APISortOption.Price,
        sortOrder: APISortOrder.Descending,
      }

    case 'price_low':
      return {
        sortOption: APISortOption.Price,
        sortOrder: APISortOrder.Ascending,
      }

    case 'topseller':
    default:
      return {
        sortOption: null,
        sortOrder: APISortOrder.Descending,
      }
  }
}

export const getSortChannel = ({
  selectedFilters,
  enableUnsponsoredDefaultSorting,
  sortId,
}: {
  selectedFilters: SelectedLooseFilterMapType
  sortId: ProductSortingIdType
  enableUnsponsoredDefaultSorting?: boolean
}): SortingChannels => {
  const hasBrandFilter = selectedFilters.brand?.length! > 0
  const hasSizeFilter = selectedFilters.categoryShopFilterSizes?.length! > 0
  const hasExplicitSorting = mapSortValues(sortId).sortOption !== null

  if (hasExplicitSorting || (!hasSizeFilter && hasBrandFilter)) {
    return SortingChannels.UnSponsoredDefault
  }

  if (hasSizeFilter && hasBrandFilter) {
    return SortingChannels.UnSponsoredWithSize
  }

  if (hasSizeFilter && !hasBrandFilter) {
    return SortingChannels.SponsoredWithSizeFilter
  }

  return enableUnsponsoredDefaultSorting
    ? SortingChannels.UnSponsoredDefault
    : SortingChannels.SponsoredDefault
}
